import { getAuthService } from '@/auth';

export async function authorizationGuard(to, _from, next) {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const token = await getAuthService().getToken();
  const now = Math.floor(new Date().getTime() / 1000);
  if((await getAuthService().getTokenClaims())?.exp <= now) {
    await getAuthService().logout();
  }

  if (requiresAuth && !token && to.path !== '/') {
    console.error('Trying to anonymously access protected route', to.fullPath);
    next({ name: 'FulfillmentSettings.Auth' });
    return;
  }
  next();
}
